// [init]

export default {


	namespaced: true,

	state: {
		// Listing of all checklists ( Array )
		checklistsList: [],

		// Current Checklist being manipulated ( viewed or edited ) ( Object )
		status: '',
		activeChecklist: {}
	},

	mutations: {

		// Update checklistList with new list
		// @params: Array
		updateChecklistList( state, newList ) {
			state.checklistsList = newList;
		},

		// Add a checklist into checklistList
		addChecklist( state, newChecklist ) {
			state.checklistsList.push( newChecklist );
		},

		// Delete a checklist from checklistList
		// @params: identifier (String)
		deleteChecklist( state, identifier ) {
			state.checklistsList = state.checklistsList.filter( checklist => {
				return checklist.id != identifier;
			} );
		},

		// Update the current active Checklist object
		// @params: newActiveChecklist (Object)
		updateActiveChecklist( state, newActiveChecklist ) {
			state.activeChecklist = newActiveChecklist;
		},

		// Change status of checklistForm
		// @params: newStatus (String)
		updateStatus( state, newStatus ) {
			state.status = newStatus;
		},

		resetState( state ) {
			state.status = '';
			state.activeChecklist = {};
		}

	},

	actions: {
		
		/* 
		*  /GET checklists API
		*  Get all checklists from the server
		*  @return: Array
		*/
		getChecklists( { commit, state } ) {

			return new Promise (( resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/checklists',
					params: {
						trash: '0',
						from: 0,
						size: 9999999
					},
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateChecklistList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET/:id checklists API
		*  Get a single checklist from the server
		*  @params: Array (due to vuex limitations)
		*  [0]: identifier (String)
		*  [1]: action (String: view/edit)
		*  @return: Object
		*/
		getSingleChecklist( { commit, state }, params ) {

			const identifier = params[0];
			const action = params[1];

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/checklists/' + identifier,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateActiveChecklist', response.data );
					commit( 'updateStatus', action );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST checklists API
		*  Add a new checklist to the server
		*  @params: Object (checklists data)
		*  @return: Object
		*/
		addChecklist( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {

				const postData = {
					english: data.english,
					chinese: data.chinese,
					category: data.category,
					position: data.position
				};

				global.axios.request({
					method: 'post',
					url: '/checklists',
					validateStatus: ( status ) => { return status == 201; },
					data: postData
				})
				.then(response => {
					commit( 'addChecklist', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});


		},

		/* 
		*  /POST/:id checklists API
		*  Edits an existing checklist into the server
		*  @params: Object (checklists data)
		*  @return: Object
		*/
		editChecklist( { commit, state }, data ) {

			return new Promise ((resolve, reject ) => {

				const postData = {
					english: data.english,
					chinese: data.chinese,
					category: data.category,
					position: data.position
				};

				global.axios.request({
					method: 'post',
					url: '/checklists/' + data.id + '/update',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
					commit( 'addChecklist', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /DELETE/:id checklists API
		*  Removes an existing checklist into the server
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		deleteChecklist( { commit, state }, identifier ) {

			return new Promise ((resolve, reject ) => {

				global.axios.request({
					method: 'post',
					url: '/checklists/' + identifier + '/trash',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'deleteChecklist', identifier );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST/:id/untrash checklists API
		*  Restores a checklist into the server from the trash
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		untrashChecklist( { commit, state }, identifier ) {

			return new Promise ( (resolve, reject) => {

				global.axios.request({
					method: 'post',
					url: '/checklists/' + identifier + '/untrash',
					validateStatus: ( status ) => { return status == 200; },
				})
				.then(response => {
					const updatedList = state.checklistsList.map(item => {
						if (item.id === identifier ) {
							let holder = item;
							holder.trash = 0;
							return holder;
						} else {
							return item;
						};
					});
					commit( 'updateChecklistList', updatedList );
				})
				.catch(error => reject( error ));

			});

		},

		reset( { commit, state } ) {
			commit( 'resetState' );
		}

	}
}


// WEBPACK FOOTER //
// ./src/custom/controllers/Checklists.js